import { createSlice } from '@reduxjs/toolkit';
const ScheduleInitialState = {
    step1: {
        plate: '',
        currentKm: '',
        fleetId: '',
        personId: '',
    },
    step2: {
        symptoms: [],
        observation: '',
        files: [],
    },
    step3: {
        scheduleDate: '',
        scheduleTime: '',
        address: '',
        name: '',
        email: '',
        phone: '',
    },
    currentStep: 1,
    images: null,
    file: null,
    multiple: null,
};
const ScheduleSlicer = createSlice({
    name: 'schedule',
    initialState: ScheduleInitialState,
    reducers: {
        setStep1: (state, { payload: step1 }) => {
            state.step1 = step1;
        },
        setStep2: (state, { payload: step2 }) => {
            state.step2 = step2;
        },
        addSymptom: (state, { payload: newSymptom }) => {
            state.step2.symptoms = [...state.step2.symptoms, newSymptom];
        },
        updateSymptom: (state, { payload: updatedSymptom }) => {
            const symptomIndex = state.step2.symptoms.findIndex(symptom => symptom.id === updatedSymptom.id);
            state.step2.symptoms[symptomIndex] = updatedSymptom;
        },
        removeSymptom: (state, { payload: removedSymptom }) => {
            const newSymptoms = state.step2.symptoms.filter(symptom => symptom.id !== removedSymptom.id);
            state.step2.symptoms = newSymptoms;
        },
        setStep3: (state, { payload: step3 }) => {
            state.step3 = step3;
        },
        setCurrentStep: (state, { payload }) => {
            state.currentStep = payload;
        },
        setFile: (state, { payload }) => {
            state.file = payload;
        },
        setMultiple: (state, { payload }) => {
            state.multiple = payload;
        },
        setImages: (state, { payload }) => {
            state.images = payload;
        },
        clearForm: () => ScheduleInitialState,
    },
});
export const { setStep1, setStep2, addSymptom, updateSymptom, removeSymptom, setStep3, clearForm, setCurrentStep, setFile, setMultiple, setImages, } = ScheduleSlicer.actions;
export default ScheduleSlicer.reducer;
